import { useSelector } from 'react-redux';
import { useLocation, useRouteLoaderData } from 'react-router';
import { SubscriptionCategory } from '../../../../../common/enums.js';
import { deepEqual } from '../../../../../common/utils/objectUtils.js';
import {
  getSubCategoryFromPath,
  pendingSubscriptionActionExistsInState,
} from '../../../../../common/utils/subscriptionUtils.js';
import { MobileSubscriptionAddons } from '../../../../../components/SubscriptionDetails/MobileSubscriptionAddons.js';
import { getMobileSubscriptionLayout } from '../../../../../components/SubscriptionLayout/subscriptionLayoutUtils.js';
import type { MobileSubscriptionLoaderResponse } from '../../../../../common/loaders.js';
import type { State } from '../../../../../selfservice/common/store.js';

export const MobileSubAddonsPath = () => {
  const { pathname } = useLocation();
  const category = getSubCategoryFromPath(pathname);
  const { subscription, hasPendingActions, companyInfo, contacts, mobileIdContracts, addOnRules, addOnRulesMobilePbx } =
    useRouteLoaderData(
      category === SubscriptionCategory.VOICE ? 'voiceSub' : 'broadbandSub'
    ) as MobileSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);

  const MobileSubLayout = getMobileSubscriptionLayout(category);

  return (
    <MobileSubLayout
      addOnRules={addOnRules}
      addOnRulesMobilePbx={addOnRulesMobilePbx}
      contacts={contacts}
      companyInfo={companyInfo}
      subscription={subscription}
    >
      <MobileSubscriptionAddons
        subscription={subscription}
        hasPendingActions={
          hasPendingActions ||
          pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState)
        }
        companyInfo={companyInfo}
        mobileIdContracts={mobileIdContracts}
        addOnRules={addOnRules}
        addOnRulesMobilePbx={addOnRulesMobilePbx}
      />
    </MobileSubLayout>
  );
};
